var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.chatList.length == 0)?_c('van-empty',{attrs:{"description":"发起一段对话吧~"}}):_c('div',{staticStyle:{"padding-top":"5%"}},[_c('ChatView',{ref:"chat_view_message",attrs:{"isSet":true,"chatList":_vm.chatList},on:{"copyMethod":_vm.copyMethod,"insertMethod":_vm.insertMethod}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }